import classes from "./TextInput.module.scss";
import { clsx } from "clsx";
import { InputHTMLAttributes, ReactNode } from "react";

type Props = {
  label?: string;
  error?: string;
  leftComponent?: ReactNode;
  rightComponent?: ReactNode;
} & InputHTMLAttributes<HTMLInputElement>;

export const TextInput = (
  {
    label,
    value = "",
    onChange,
    error,
    leftComponent,
    rightComponent,
    ...props
  }: Props
) => {
  return (
    <div className="TextInput">
      { label && <label className={classes.Label}>{label}</label> }

      <div className={classes.InputContainer}>
        <input
          className={clsx(classes.Input, { [classes.HasError]: !!error })}
          value={value}
          onChange={onChange}
          {...props}
        />

        { leftComponent && <div className={classes.LeftContent}>{leftComponent}</div> }

        { rightComponent && <div className={classes.RightContent}>{rightComponent}</div> }
      </div>

      { error && <div className={classes.Error}>{error}</div> }
    </div>
  );
};
